module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-BlackItalic-6b225351faa7f01bbfcc7d43f516184d.ttf";